export default "__VITE_ASSET__BPb8c8K$__"